import React from "react";
import links from "../data-list/links";

const HeroSection = () => {
  let imgPath = process.env.PUBLIC_URL + "assets/media/";
  let textLogo = imgPath + "logo.JPG";
  let heroImage = imgPath + "home.png";
  return (
    <div
      className="slider-area bg-color horizontal bg-shape"
      id="home"
      style={{ background: "rgba(51, 138, 93, 0.85)" }}
    >
      <div className="container h-100">
        <div className="row">
          <div className="col-lg-7 h-100">
            <div className="banner-text">
              <div className="banner-table-cell">
                <h1>
                  <img src={textLogo} alt="logo full" />
                </h1>
                <h1>
                  <span></span> mobility app for everyone
                </h1>
                <p style={{ fontSize: 20 }}>
                  Our app connects commuters who want to share rides and allows
                  them to request on-demand drivers. It also provides public
                  transport directions to assist with trip planning.
                </p>
                <p style={{ fontSize: 20 }}>
                  In addition, riders can also purchase public transport tickets
                  in certain markets as well as share their live vehicle
                  location with others during their ride.
                </p>
                <div className="banner-buttons">
                  <a
                    // style={{ marginRight: 5 }}
                    target="_blank"
                    className="button-default button-olive"
                    rel="noreferrer"
                    href={links.playstore}
                  >
                    <i className="zmdi zmdi-apple"></i> Play Store
                  </a>
                  <a
                    target="_blank"
                    className="button-default button-white"
                    rel="noreferrer"
                    href={links.appstore}
                  >
                    <i className="zmdi zmdi-google-play"></i> App Store
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-5">
            <div className="banner-product-image text-right">
              <img className="image-1" src={heroImage} alt="App Landing" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
